(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

jQuery(document).ready(function ($) {
  $('#start_hour, #end_hour').timepicker({
    timeFormat: 'H:mm',
    interval: 15,
    minTime: '00',
    maxTime: '23',
    defaultTime: 'value',
    startTime: '0',
    dynamic: false,
    dropdown: true,
    scrollbar: true
  });
  var selected_option = $("#category_delivery_time option:selected").val();

  if (selected_option == 1 || selected_option == 2) {
    $('#category_delivery_time_next_day').css('display', 'table-row');
  }

  if (selected_option == 3) {
    $('#category_delivery_time_next_day').css('display', 'table-row');
    $('#category_delivery_time_custom_dates').css('display', 'table-row');
  }

  $("#category_delivery_time select").on('change', function () {
    if ($(this).val() == 0) {
      $('#category_delivery_time_next_day').css('display', 'none');
      $('#category_delivery_time_custom_dates').css('display', 'none');
    } else if ($(this).val() == 3) {
      $('#category_delivery_time_next_day').css('display', 'table-row');
      $('#category_delivery_time_custom_dates').css('display', 'table-row');
    } else {
      $('#category_delivery_time_next_day').css('display', 'table-row');
      $('#category_delivery_time_custom_dates').css('display', 'none');
    }
  });
});

},{}]},{},[1]);
